module.exports = __webpack_public_path__ + "static/img/ml003.c0392cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ml003.jpg
// module id = 8x9J
// module chunks = 1